import { __assign } from "tslib";
import { defaultFieldResolver } from 'graphql';
import { mapSchema, MapperKind } from '@graphql-tools/utils';
function decorateToCatchUndefined(fn, hint) {
    var resolve = fn == null ? defaultFieldResolver : fn;
    return function (root, args, ctx, info) {
        var result = resolve(root, args, ctx, info);
        if (typeof result === 'undefined') {
            throw new Error("Resolver for \"" + hint + "\" returned undefined");
        }
        return result;
    };
}
export function addCatchUndefinedToSchema(schema) {
    var _a;
    return mapSchema(schema, (_a = {},
        _a[MapperKind.OBJECT_FIELD] = function (fieldConfig, fieldName, typeName) { return (__assign(__assign({}, fieldConfig), { resolve: decorateToCatchUndefined(fieldConfig.resolve, typeName + "." + fieldName) })); },
        _a));
}
//# sourceMappingURL=addCatchUndefinedToSchema.js.map